import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapestcabserviceinnavimumbai() {



const cardData = {
  keyword: " Cheapest Cab Service in Navi Mumbai ",

headingDescription: "Velocity Cab provides the cheapest cab service in Navi Mumbai, offering budget‑friendly and reliable taxi options for local rides, airport transfers, outstation trips, and corporate travel. We focus on affordable pricing with transparent rates, no hidden charges, and comfortable travel that fits every budget. Our fleet includes well‑maintained economy cars, air‑conditioned sedans, and hatchbacks driven by professional drivers who ensure punctual pickups and safe journeys across Navi Mumbai and nearby areas. With easy online booking and 24/7 customer support, Velocity Cab is the trusted and economical choice for cheap cab services in Navi Mumbai.",

topPlaces: [

 
  {
    title: "Matheran",
    description: "Matheran is India’s smallest hill station and a unique eco-friendly destination near Mumbai. Known for its vehicle-free environment, visitors can explore viewpoints like Panorama Point and Echo Point while enjoying horse rides and walking trails."
  },
    {
    title: "Lonavala",
    description: "Lonavala is one of the most popular outstation destinations from Mumbai, known for its lush green valleys, misty hills, and scenic waterfalls. Travelers booking a sedan cab can enjoy a comfortable drive via the Mumbai–Pune Expressway and visit attractions like Tiger Point, Bhushi Dam, and Lion’s Point for breathtaking views."
  },
  {
    title: "Nashik",
    description: "Nashik is a major pilgrimage and wine tourism destination near Mumbai, famous for the Trimbakeshwar Temple and Sula Vineyards. Travelers can enjoy spiritual visits, vineyard tours, and scenic riverfront experiences along the Godavari River."
  },
   {
    title: "Alibaug",
    description: "Alibaug is a beautiful coastal getaway near Mumbai famous for its clean beaches, sea forts, and relaxed vibe. Visitors can enjoy Alibaug Beach, Kolaba Fort, and Mandwa Jetty while experiencing a peaceful seaside escape perfect for weekend trips."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a serene hill station located in the Western Ghats, known for its lush greenery, waterfalls, and calm environment. It is ideal for meditation retreats, nature walks, and scenic drives through fog-covered mountains."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India’s most important pilgrimage sites dedicated to Sai Baba. Visitors can visit the Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi while experiencing a peaceful spiritual atmosphere."
  },
  {
    title: "Saputara",
    description: "Saputara is a picturesque hill station in Gujarat near the Maharashtra border, known for its cool climate, lakes, and viewpoints. It offers boating, ropeway rides, and scenic sunset spots ideal for family trips."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a charming hill station near Mumbai famous for its strawberry farms, Table Land plateau, and scenic valley views. It is perfect for relaxing holidays and nature photography."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for its cool weather, strawberry farms, and viewpoints like Arthur’s Seat and Elephant’s Head Point. It is ideal for long weekend getaways from Mumbai."
  },
  {
    title: "Kashid Beach",
    description: "Kashid Beach is a peaceful coastal destination near Mumbai known for its white sand, clear waters, and water sports activities. It is a great spot for relaxation, camping, and seaside drives."
  }
],



services: [
{
name: "Cheap Cab Service Navi Mumbai",
description: "Cheap cab service Navi Mumbai provides affordable and reliable transportation for daily commuting, airport transfers, and outstation travel. This service is ideal for budget-conscious travelers who want comfortable rides at economical prices. Customers can choose from a variety of vehicles including hatchbacks, sedans, and SUVs based on their requirements. Professional drivers ensure safe and smooth journeys across Navi Mumbai and nearby cities. Transparent pricing with no hidden charges helps customers plan their travel budget easily. Flexible booking options and 24x7 availability add convenience for all types of travelers. It is the perfect solution for cost-effective and dependable cab services in Navi Mumbai."
},
{
name: "Budget Taxi Navi Mumbai",
description: "Budget taxi Navi Mumbai offers economical travel solutions for individuals, families, and corporate travelers. This service is designed to provide affordable rides without compromising on safety and comfort. Vehicles are well-maintained with clean interiors and smooth performance. Professional drivers ensure timely pickups and safe travel across all routes. Flexible booking options make it easy to plan trips in advance or instantly. It is ideal for daily commuting and outstation travel. It ensures reliable service at affordable rates."
},
{
name: "Lowest Price Cab Navi Mumbai",
description: "Lowest price cab Navi Mumbai provides highly competitive fares for customers looking for the most economical travel options. This service is perfect for students, office commuters, and frequent travelers who want budget-friendly rides. Transparent pricing ensures no extra or hidden charges. Vehicles are maintained for safe and comfortable travel. Professional drivers ensure smooth journeys across city and highway routes. Easy booking options make it convenient for users. It is one of the best choices for low-cost travel in Navi Mumbai."
},
{
name: "Affordable Taxi Service Navi Mumbai",
description: "Affordable taxi service Navi Mumbai delivers cost-effective travel solutions for all types of journeys including local rides, airport transfers, and outstation trips. This service ensures comfortable rides with well-maintained vehicles and trained drivers. Customers can choose from multiple vehicle options depending on their travel needs. Transparent billing ensures clarity in fares without hidden costs. Flexible pickup and drop locations enhance convenience. It is widely preferred for budget-friendly transportation. It ensures a smooth and comfortable travel experience."
},
{
name: "Cheap Airport Cab Navi Mumbai",
description: "Cheap airport cab Navi Mumbai offers budget-friendly airport pickup and drop services with timely and reliable transportation. This service is ideal for travelers heading to or from Mumbai Airport from Navi Mumbai locations like Vashi, Nerul, Belapur, and Panvel. Drivers track flight timings to ensure punctual pickups even during late-night or early-morning schedules. Clean and comfortable vehicles enhance the travel experience. Flexible booking options make it easy to reserve a cab. It ensures a smooth and stress-free airport journey. It is perfect for affordable airport transfers."
},
{
name: "Cheap Outstation Cab Navi Mumbai",
description: "Cheap outstation cab Navi Mumbai provides economical travel options for long-distance trips to destinations like Pune, Nashik, Lonavala, Shirdi, and Goa. This service is ideal for travelers looking for affordable intercity transportation without compromising comfort. Vehicles are well-maintained for highway travel ensuring safe journeys. Flexible packages include one way and round trip options. Professional drivers ensure smooth and timely travel. Transparent pricing helps customers plan budgets easily. It is a great option for cost-effective outstation travel."
},
{
name: "Low Fare Taxi Navi Mumbai",
description: "Low fare taxi Navi Mumbai offers economical travel options for daily commuting and long-distance trips. This service is designed for customers who want reliable transportation at minimal cost. Vehicles are clean, comfortable, and maintained for safe travel. Professional drivers ensure timely pickups and smooth journeys. Flexible booking options make travel planning easy. It is ideal for budget-conscious travelers. It ensures affordable and convenient transportation."
},
{
name: "Economy Cab Service Navi Mumbai",
description: "Economy cab service Navi Mumbai provides practical and budget-friendly transportation solutions for city and outstation travel. This service is suitable for travelers who prioritize affordability while maintaining basic comfort standards. Vehicles are well-maintained and efficient for daily travel needs. Professional drivers ensure safe and reliable service. Flexible booking options make it convenient for all customers. It is widely preferred for economical travel solutions. It ensures dependable service at low cost."
},
{
name: "Discount Cab Booking Navi Mumbai",
description: "Discount cab booking Navi Mumbai offers special deals and reduced fares for customers looking to save on travel expenses. This service is ideal for frequent travelers and those booking in advance. Customers can take advantage of seasonal discounts, promotional offers, and bulk booking benefits. Transparent pricing ensures no hidden charges. Professional drivers ensure safe and comfortable journeys. Easy booking options make it convenient for all users. It is a great way to enjoy affordable travel with added savings."
}
],

tableData: [
["Cheap Cab Service Navi Mumbai","Budget Taxi Navi Mumbai"],
["Lowest Price Cab Navi Mumbai","Affordable Taxi Service Navi Mumbai"],
["Cheap Airport Cab Navi Mumbai","Cheap Outstation Cab Navi Mumbai"],
["Low Fare Taxi Navi Mumbai","Economy Cab Service Navi Mumbai"],
["Discount Cab Booking Navi Mumbai","Cheap Cab Service Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable & Budget-Friendly Pricing",
    WhyChoosedescription: "Velocity Cabs offers cheapest cab service in Navi Mumbai with highly competitive fares, making it ideal for daily travel, airport transfers, and outstation trips at the lowest cost."
  },
  {
    WhyChooseheading: "Transparent Fare Structure",
    WhyChoosedescription: "We provide complete pricing transparency with clear fare details including per km charges, tolls, and driver allowance, ensuring no hidden costs for customers."
  },
  {
    WhyChooseheading: "Best Price Compared to Market Rates",
    WhyChoosedescription: "In Navi Mumbai, taxi fares typically range around ₹11 to ₹20 per km depending on vehicle type and service :contentReference[oaicite:0]{index=0}, and Velocity Cabs ensures highly competitive and economical pricing for customers."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our cheapest cab service in Navi Mumbai operates 24/7, allowing customers to book rides anytime for local, airport, or outstation travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and stress-free travel experience at affordable prices."
  },
  {
    WhyChooseheading: "Multiple Budget Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers hatchbacks, sedan cars, and SUVs like Ertiga and Innova, allowing customers to choose budget-friendly travel options based on their needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and airports across Navi Mumbai for easy and hassle-free travel."
  },
  {
    WhyChooseheading: "Trusted Low Cost Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for cheapest cab service in Navi Mumbai due to reliable drivers, affordable pricing, and consistent service quality."
  }
]
};

const faqData = [
  { question: "Do you provide cheapest cab service in Navi Mumbai?", answer: "Yes, Velocity Cabs provides budget-friendly cab services in Navi Mumbai for local, airport, and outstation travel." },
  { question: "What is the starting fare of cabs in Navi Mumbai?", answer: "Cab fares in Navi Mumbai generally start from around ₹11 to ₹20 per km depending on the vehicle type and service." },
  { question: "Which is the cheapest cab option?", answer: "Hatchback and sedan cars are the most economical options for budget travel in Navi Mumbai." },
  { question: "Is cheap cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for customer convenience." },
  { question: "Can I book cheap cab for airport transfer?", answer: "Yes, we provide affordable airport pickup and drop services in Navi Mumbai." },
  { question: "Are low-cost cabs safe?", answer: "Yes, all our drivers are verified and vehicles are well maintained to ensure safe travel." },
  { question: "Can I book cab online at low price?", answer: "Yes, customers can easily book cheapest cab service in Navi Mumbai online or through phone booking." },
  { question: "Do you provide one-way cheap cabs?", answer: "Yes, we offer both one-way and round-trip affordable cab options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended to get the best price and availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback:
      "Booked cheapest cab service in Navi Mumbai with Velocity Cabs. Very affordable pricing and smooth ride experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Joshi",
    feedback:
      "Best budget cab service in Navi Mumbai. Clean car, polite driver, and reasonable fare made my trip comfortable.",
    rating: 5
  }
];





















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const cheapestCabNaviMumbaiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Cheapest Cab Service in Navi Mumbai | Velocity Cabs",
  "description": "Book the cheapest cab service in Navi Mumbai for city trips, airport transfers, or outstation travel. AC, Sedan, and SUV taxis available at affordable fares for one-way or round trips.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Cheapest Cab Packages in Navi Mumbai",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "Cheap One Way Cab in Navi Mumbai",
        "description": "Affordable one-way cab service in Navi Mumbai with AC, SUV, or Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Cheap Cab in Navi Mumbai",
        "description": "Budget-friendly round-trip cab service in Navi Mumbai with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};



  return (
    <div>
      


<Helmet>
  <title>Cheapest Cab Service in Navi Mumbai | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book the cheapest cab service in Navi Mumbai for city trips, airport transfers, or outstation travel. AC, Sedan, and SUV taxis available at affordable fares for one-way or round trips."
  />
  <script type="application/ld+json">
    {JSON.stringify(cheapestCabNaviMumbaiJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/111.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cheapestcabserviceinnavimumbai;